import { render } from "./QariList.vue?vue&type=template&id=1f869eae"
import script from "./QariList.vue?vue&type=script&lang=js"
export * from "./QariList.vue?vue&type=script&lang=js"
script.render = render

export default script